import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../../services';
import { localStorageVar } from 'src/app/modules/admin/pages/localstoragevar';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {
  constructor(private _router: Router, private auth: AuthService) { }
  canActivate() {
    if (this.auth.user?.role?.toLowerCase() == "admin") {
      // check account level and current route
      // if (localStorage.getItem(localStorageVar.accountLevel) == "1") {
      //   this._router.navigate(['auth/onboarding'])
      // } else 
        if (localStorage.getItem(localStorageVar.accountLevel) == "2" &&
        !this._router.getCurrentNavigation()?.finalUrl.toLocaleString().startsWith("/admin")) {
        this._router.navigate(['admin'])
      }
      return true;
    } else {
      this._router.navigate(['/', this.auth.user?.role?.toLowerCase() ?? '']);
      return false;
    }
  }

}
